import React from "react";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withIntl from "../../../utils/withIntl";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, IconButton, Typography } from "@material-ui/core";
import { useDialog } from "../../Dialogs/DialogProvider";
import { Close } from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import EditTextField from "../../EditArticle/EditTextField";
import { Modifierarticle } from "../../../store/articles/models/Modifierarticle";
import EditPriceTextField from "../../EditArticle/EditPriceTextField";
import { createModifierarticles } from "../../../store/articles/ModifierarticlesApi";
import articlesStore from "../../../store/articles/ArticlesStore";
import cloudStore from "../../../store/CloudStore";
import Flag from "react-flags";
import getFlagName from "../../../helper/GetFlagName";
import EditSwitch from "../../EditArticle/EditSwitch";

const useStyles = makeStyles(() => ({
  listAllergens: {
    display: "flex",
  },
  marginBottom10: {
    marginBottom: 10,
  },
  padding10: {
    padding: 10,
  },
}));

function NewModifierarticleDialog(props) {
  const classes = useStyles();
  const filteredPlus = [];
  Object.keys(articlesStore.modifierarticles).forEach((key) => {
    if (!isNaN(articlesStore.modifierarticles[key].plu)) filteredPlus.push(articlesStore.modifierarticles[key].plu);
  });
  const newModifierarticle = new Modifierarticle(
    undefined,
    undefined,
    undefined,
    "",
    undefined,
    Math.min(
      ...Object.keys(articlesStore.modifierarticles).map(
        (modifierarticleIds) => articlesStore.modifierarticles[modifierarticleIds].priority
      )
    ) - 1,
    false,

    Math.max(...filteredPlus) + 1,
    undefined,
    undefined,
    null,
    false,
    "",
    [props.modifiergroup.id],
    undefined
  );

  const [modifierarticle, setModifierarticle] = React.useState(
    Object.assign(new Modifierarticle(), newModifierarticle)
  );
  const [, closeDialog] = useDialog();

  const handleCloseDialog = () => {
    if (modifierarticle.name) {
      const cancel = window.confirm(props.intl.formatMessage({ id: "unsaved_changes_will_be_lost" }));
      if (cancel === true) {
        closeDialog();
      }
    } else {
      closeDialog();
    }
  };

  const handleSetModifierarticle = (key, value) => {
    const newModifierarticle = Object.assign(new Modifierarticle(), modifierarticle);
    newModifierarticle[key] = value;
    setModifierarticle(newModifierarticle);
  };

  return (
    <>
      <DialogTitle id="form-dialog-title">
        <div style={{ display: "flex" }}>
          <Typography variant={"h5"}>{props.intl.formatMessage({ id: "create_new_modifierarticle" })}</Typography>
          <IconButton disabled>
            <Flag
              name={getFlagName(cloudStore.merchant.default_language)}
              format="png"
              pngSize={16}
              shiny={true}
              basePath={"/flags"}
            />
          </IconButton>
        </div>
        <IconButton
          onClick={handleCloseDialog}
          color="primary"
          style={{ position: "absolute", top: "8px", right: "8px" }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent key={"key"}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            createModifierarticles(articlesStore.merchantId, [modifierarticle]);
            closeDialog();
          }}
        >
          <Grid container xs={12} alignContent={"flex-start"} spacing={1} className={classes.padding10}>
            <Grid item className={classes.marginBottom10} xs={7}>
              <EditTextField
                inputProps={{ required: true }}
                key={modifierarticle.key}
                authorizationField={"article.name"}
                label={props.intl.formatMessage({ id: "article_name" })}
                value={modifierarticle.name == null ? "" : modifierarticle.name}
                onBlur={(value) => handleSetModifierarticle("name", value)}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={5}>
              <EditPriceTextField
                authorizationField={"article.price"}
                label={props.intl.formatMessage({ id: "price" })}
                price={modifierarticle.price}
                onBlur={(value, setBeginValue) => {
                  if (value == null) {
                    value = 0;
                  }
                  handleSetModifierarticle("price", value);
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={7}>
              <EditTextField
                key={modifierarticle.key}
                authorizationField={"article.print_name"}
                label={props.intl.formatMessage({ id: "batch.print_name" })}
                value={modifierarticle.print_name == null ? "" : modifierarticle.print_name}
                onBlur={(value) => handleSetModifierarticle("print_name", value)}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={5}>
              <EditTextField
                key={modifierarticle.key}
                authorizationField={"article.print_name_2"}
                label={props.intl.formatMessage({ id: "batch.print_name_2" })}
                value={modifierarticle.print_name_2 == null ? "" : modifierarticle.print_name_2}
                onBlur={(value) => handleSetModifierarticle("print_name_2", value)}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={7}>
              <EditTextField
                key={modifierarticle.key}
                authorizationField={"article.pos_name"}
                label={props.intl.formatMessage({ id: "batch.pos_name" })}
                value={modifierarticle.pos_name == null ? "" : modifierarticle.pos_name}
                onBlur={(value) => handleSetModifierarticle("pos_name", value)}
                variant={"standard"}
              />
            </Grid>
            <Grid xs={5} />
            <Grid xs={3}>
              <EditSwitch
                label={"manual_active"}
                authorizationField={"modifierarticle.manual_active"}
                value={modifierarticle.manual_active}
                onChange={(value) => handleSetModifierarticle("manual_active", value)}
              />
            </Grid>
            <Grid xs={3}>
              <EditSwitch
                label={"handheld_only"}
                authorizationField={"modifierarticle.handheld_only"}
                value={modifierarticle.handheld_only}
                onChange={(value) => handleSetModifierarticle("handheld_only", value)}
              />
            </Grid>
            <Grid xs={3}>
              <EditSwitch
                label={"batch.is_side_dish"}
                authorizationField={"modifierarticle.is_side_dish"}
                value={modifierarticle.is_side_dish}
                onChange={(value) => handleSetModifierarticle("is_side_dish", value)}
              />
            </Grid>
          </Grid>
          <Button variant={"outlined"} type="submit" style={{ marginRight: "5px", float: "right" }}>
            {props.intl.formatMessage({ id: "add" })}
          </Button>
        </form>
      </DialogContent>
    </>
  );
}

export default withIntl(NewModifierarticleDialog);
